// extracted by mini-css-extract-plugin
export default {"menu":"menu-module__menu___vS1fB","subMenu":"menu-module__subMenu___APpxZ","divider":"menu-module__divider___vUBcN","arrowRight":"menu-module__arrowRight___Kp980"};